import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-medicals',
  templateUrl: './medicals.component.html',
  styleUrls: ['./medicals.component.css']
})
export class MedicalsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
